import { getProvider, setStateFromPayload } from "../navigoSlice";
import { modeRequiresLocation } from "./locationModes";
import { withFrom } from "./navBack";

// Provider-search request body used by the default (non-geolocation) path.
function buildProviderBody({ patientId, planId, service, modeName }) {
  return {
    cityMatch: [],
    landmarkMatch: [],
    languageMatch: [],
    pageNum: 0,
    pageSize: 0,
    patientId,
    planId,
    serviceId: service?.serviceId,
    serviceMode: modeName,
    stateMatch: [],
  };
}

// Routes a (service, mode) pair into the correct next screen. For health
// checkups (serviceTypeId === 2): "Home sample" -> /bookingFor and
// location-based modes (e.g. "Centre visit") -> /select-location; everything
// else fetches providers and goes to /providerCard.
//
// NOTE: downstream screens read service.serviceModeDetails[0], so the caller
// must pass a service whose FIRST mode is the chosen one.
export function routeForServiceMode({
  routeLocation,
  service,
  modeName,
  planId,
  pageType,
  patientId,
  dispatch,
  history,
}) {
  const isHealthCheckup = service?.serviceTypeId === 2;

  // Seed the booking summary (shown in the bottom floater) with the committed
  // service + mode, and clear any stale member/address from a prior booking.
  dispatch(
    setStateFromPayload({
      currentServices: service,
      selectedBookingMode: modeName,
      selectedBookingProvider: null,
      familyMemberSelectedData: {},
      addressSelected: null,
      // Nothing else resets these, so a location picked in an earlier maps
      // session would otherwise still be attached to this booking — and the
      // provider screen keys its location filter off pickedLocation. The maps
      // flow sets them again in selectLocation once the user picks.
      pickedLocation: null,
      centreFilter: null,
    }),
  );

  if (isHealthCheckup && modeName === "Home sample") {
    dispatch(
      setStateFromPayload({
        currentSelectedService: service,
        currentSelectedPlan: planId,
      }),
    );
    history.push("/bookingFor", withFrom(routeLocation));
    return;
  }

  if (isHealthCheckup && modeRequiresLocation(modeName)) {
    history.push({
      pathname: "/select-location",
      state: withFrom(routeLocation, { service, pageType, planId }),
    });
    return;
  }

  dispatch(
    getProvider(buildProviderBody({ patientId, planId, service, modeName })),
  );
  history.push({
    pathname: "/providerCard",
    state: withFrom(routeLocation, { service, pageType }),
  });
}
